const redirectKey = 'redirect'

export class SigninGuard {
  static redirectToLoginPage(destination: string = location.href) {
    const host = process.env.VUE_APP_WEBSITE_DOMAIN

    location.href = `https://${host}/login?${redirectKey}=${encodeURI(destination)}`
  }

  static redirectToDestination() {
    const url = new URL(location.href)
    const redirectURL = url.searchParams.get(redirectKey)
    location.href = redirectURL ? decodeURI(redirectURL) : '/'
  }
}
